import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h6>AffSimple.com</h6>
            <p className="footer-company">
              Operated by Skjoldan Consulting<br />
              CVR: DK21417289<br />
              Denmark
            </p>
          </div>
          
          <div className="footer-section">
            <h6>Legal</h6>
            <div className="footer-links">
              <Link to="/terms" className="footer-link">Terms & Conditions</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <button 
                className="footer-link cookie-settings-btn" 
                onClick={() => {
                  localStorage.removeItem('cookie-consent');
                  window.location.reload();
                }}
              >
                Cookie Settings
              </button>
            </div>
          </div>
          
          <div className="footer-section">
            <h6>Contact</h6>
            <div className="footer-links">
              <a href="mailto:support@affsimple.com" className="footer-link">Support</a>
              <a href="mailto:support@affsimple.com" className="footer-link">Privacy</a>
              <a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer" className="footer-link">Datatilsynet</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            &copy; {currentYear} Skjoldan Consulting. All rights reserved.
          </div>
          <div className="footer-compliance">
            GDPR Compliant | Danish Company
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
